import { apiCall } from '@/lib/api-client';
import type { AuditLogPage, AuditLogFilters } from '@/types/api';

export const auditApi = {
  list: (filters: AuditLogFilters, limit = 50, offset = 0) => {
    const params = new URLSearchParams();
    params.set('limit', String(limit));
    params.set('offset', String(offset));
    if (filters.action) params.set('action', filters.action);
    if (filters.userQuery) params.set('userQuery', filters.userQuery);
    if (filters.from) params.set('from', filters.from);
    if (filters.to) params.set('to', filters.to);
    return apiCall<AuditLogPage>(`/admin/audit?${params.toString()}`);
  },
};
